export enum AptProductFamily {
    Commodity = 'Commodity',
    CommodityLegacy = 'Commodity Legacy',
    CommodityLegacyFull = 'Commodity Legacy Full',
    CommodityLuceResidenziale = 'Commodity Luce Residenziale',
    CommodityGasResidenziale = 'Commodity Gas Residenziale',
    CommodityLuceMicrobusiness = 'Commodity Luce Microbusiness',
    CommodityGasMicrobusiness = 'Commodity Gas Microbusiness',
    BeniFisici = 'Beni Fisici senza installazione',
    ServizioTecnico = 'Servizi con tecnico',
    VariazioneTecnica = 'Variazione Tecnica',
    Assicurazione = 'Assicurazione',
    Options = 'Options',
    Pannello = 'Pannello',
    BroadBand = 'BroadBand'
}

export const APT_COMMODITY_FAMILY_CONST = [
    AptProductFamily.Commodity,
    AptProductFamily.CommodityLegacy,
    AptProductFamily.CommodityLegacyFull,
    AptProductFamily.CommodityLuceResidenziale,
    AptProductFamily.CommodityGasResidenziale,
    AptProductFamily.CommodityLuceMicrobusiness,
    AptProductFamily.CommodityGasMicrobusiness
] as const;

export const APT_COMMODITY_LEGACY_FAMILY_CONST = [
    AptProductFamily.CommodityLegacy,
    AptProductFamily.CommodityLegacyFull
] as const;

// Assign the commodity field to all families listed in APT_COMMODITY_FAMILY_CONST
export function commodityProductFamilyMapEnricher(MAP_TO_ENRICH: any, dataToAssign: any): any {
    (APT_COMMODITY_FAMILY_CONST || []).forEach((fam) => (MAP_TO_ENRICH[fam] = dataToAssign));
    return MAP_TO_ENRICH;
}
